// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el))

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach((el) => new bootstrap.Popover(el))

// Autofocus on search field on offcanvas open
document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', () => {
    document.querySelector('#predictive-search-input').focus()
})

// Shopify's callenge page - Add BS classes
document.querySelector('.btn.shopify-challenge__button')
    ?.classList.add('btn-primary')

// Shopify's errors message - Add BS classes
const errors = document.querySelector('.errors')
if (errors) {
    errors.classList.add('alert', 'alert-danger')
    errors.querySelector('ul').classList.add('mb-0')
}

// Detect viewport
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
const initEnterViewAnimations = () => {
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // console.log(entry)
                entry.target.classList.add('entered')
                entry.target.querySelectorAll('.animate__animated').forEach((el) => {
                    el.classList.remove('opacity-0')
                    el.classList.add(el.dataset.animateClass)
                })
            }
        })
    }, { threshold: 0, rootMargin: '0px 0px -160px 0px' })

    document.querySelectorAll('.enter-view').forEach((el) => {
        observer.observe(el)
    })
}
initEnterViewAnimations()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.enter-view')) {
        initEnterViewAnimations()
    }
})

/* Detect scroll */
window.addEventListener('scroll', (e) => {
    const announcementbarHeight = document.querySelector('#shopify-section-announcement-bar').clientHeight || 0
    if (window.scrollY > announcementbarHeight) {
        document.body.classList.add('scrolled')
    } else {
        document.body.classList.remove('scrolled')
    }
})

// Fix responsive youtube iframes
document.querySelectorAll('.rte iframe[src*=youtube').forEach(el => {
    const wrapper = document.createElement('div')
    wrapper.classList.add('ratio', 'ratio-16x9')
    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(el)
})

// Colors swatches on product list items - Handle image change
document.querySelectorAll('.product-list-item input[name="id"]').forEach(el => {
    el.addEventListener('change', (e) => {
        const variantImage = e.target.dataset.variantImage
        const currentImage = e.target.closest('.product-list-item').querySelector('img.product-img')

        currentImage.setAttribute('src', variantImage)
    })
})

// Color swatches on product list items - Show all swatches on button click
document.querySelectorAll('.btn-color-swatches-show-all').forEach(btn => {
    btn.addEventListener('click', () => {
        btn.classList.remove('d-flex')
        btn.classList.add('d-none')
        btn.closest('form').querySelectorAll('.color-swatches li').forEach(el => {
            el.classList.remove('d-none')
        })
    })
})

// Countdown timer for the cart page
const initCartTimer = () => {
    const el = document.querySelector('.cart-timer')

    if (el) {
        let timer = Number(el.dataset.timerSec)
        const duration = timer
        setInterval(() => {
            let minutes = parseInt(timer / 60, 10)
            let seconds = parseInt(timer % 60, 10)

            minutes = minutes < 10 ? '0' + minutes : minutes
            seconds = seconds < 10 ? '0' + seconds : seconds

            el.querySelector('strong').textContent = minutes + ':' + seconds

            if (--timer < 0) {
                timer = duration
            }
        }, 1000)
    }
}
initCartTimer()

// Confetti effect
// https://dev.to/official_fire/creating-a-confetti-effect-in-5-minutes-16h3
// const initConfetti = () => {
//     if (document.querySelector('body.page-type-index')) {
//         setTimeout(() => {
//             confetti.start()
//         }, 2000)

//         setTimeout(() => {
//             confetti.stop()
//         }, 6000)
//     }
// }
// initConfetti()

/*
    Second image on hover effect (product list items)
*/
document.querySelectorAll('.product-list-item img[data-second-img-src]').forEach((img) => {
    const wrapper = img.closest('.img-wrapper')

    wrapper.addEventListener('mouseover', () => {
        img.src = img.dataset.secondImgSrc
    })
    wrapper.addEventListener('mouseleave', () => {
        img.src = img.dataset.mainImgSrc
    })
})


    console.log(
  "%cDESIGNED AND DEVELOPED BY ECOMGRADUATES",
  "-webkit-text-stroke: 0.2vw #a61b30;    font-family: fantasy;    font-size: 7vw;    padding: 3px 0 13px 31px;    letter-spacing: 0vw;    text-transform: uppercase;    background: rgb(226,69,212);    background: linear-gradient(90deg, rgba(226,69,212,1) 3%, rgba(223,28,127,1) 48%, rgba(213,36,42,1) 98%);    margin: 0;    text-align: left;    font-weight: 700;    color: #fff;    text-shadow: -3px 4px 13px #460f17, -11px 7px 20px #080203;"
);
console.log("https://ecomgraduates.com");